import { DateUtil } from '@src/packages/utils/dates';
import { ATTENDANCE_EVENT_TYPE } from '@src/packages/workJourney/constants';

import type { MarkAttendanceConfirmKind, MarkAttendanceJourneyDetails } from '../types';

export const MARK_SCHEDULE_TOLERANCE_MINUTES = 5;

const SCHEDULED_TIME_BY_MARK_KIND: Record<
  MarkAttendanceConfirmKind,
  keyof Pick<
    MarkAttendanceJourneyDetails,
    | 'scheduledStartAtSeconds'
    | 'scheduledBreakStartAtSeconds'
    | 'scheduledBreakEndAtSeconds'
    | 'scheduledEndAtSeconds'
  >
> = {
  [ATTENDANCE_EVENT_TYPE.SHIFT_START]: 'scheduledStartAtSeconds',
  [ATTENDANCE_EVENT_TYPE.BREAK_START]: 'scheduledBreakStartAtSeconds',
  [ATTENDANCE_EVENT_TYPE.BREAK_END]: 'scheduledBreakEndAtSeconds',
  [ATTENDANCE_EVENT_TYPE.SHIFT_END]: 'scheduledEndAtSeconds',
};

export const isMarkOutsideScheduleTolerance = ({
  kind,
  markedAt,
  journeyDetails,
}: {
  kind: MarkAttendanceConfirmKind | null;
  markedAt: Date | null;
  journeyDetails: MarkAttendanceJourneyDetails | null;
}): boolean => {
  if (!kind || !markedAt || !journeyDetails) {
    return false;
  }

  const scheduledAtSeconds = journeyDetails[SCHEDULED_TIME_BY_MARK_KIND[kind]];
  if (scheduledAtSeconds == null) {
    return false;
  }

  const scheduledAtMs = DateUtil.toDate(scheduledAtSeconds).getTime();
  const toleranceMs = MARK_SCHEDULE_TOLERANCE_MINUTES * 60 * 1000;

  return Math.abs(markedAt.getTime() - scheduledAtMs) > toleranceMs;
};
